import { shareHitMethodStatisticsApi } from 'api/sharingContentApi'
import { SharingType } from 'components/block/SharingContent/SharingContent.constant'

import { AsyncAction } from '../actions.types'

export const SHARE_HIT_METHOD = 'SHARE_HIT_METHOD' as const

export interface ShareHitMethodAction extends AsyncAction<Response> {
  type: typeof SHARE_HIT_METHOD
}

export const shareHitMethodStatisticsAction = (
  typeSharing: SharingType,
  contentId: number,
  profileId: number,
  sharingMethod: unknown
): ShareHitMethodAction => ({
  type: SHARE_HIT_METHOD,
  promise: () =>
    shareHitMethodStatisticsApi(
      typeSharing,
      contentId,
      profileId,
      sharingMethod
    ),
})
